import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Riporta la pagina in cima ad ogni cambio di route (pathname). Non scatta sui
// cambi di query string (es. filtri della ricerca), così i filtri non fanno saltare lo scroll.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default ScrollToTop;
